import React from "react";
import ReactDOM from "react-dom";
import Application from "./pages/application";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import { config } from "dotenv";

config();

ReactDOM.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
